export default __webpack_public_path__ + "static/prestressed-concrete-981ecf48236668bd2e99d00ed37a3153.jpg";